(function($){
  /**
   * footer setting and control
   *
   */
   OH.settings.footerControl = (function(){
     var control = new Object();
     
     /**
      * footer copylight to Upper case
      */
      control.copylightUpper = function($target){
        var upperResult = $target.text().toUpperCase();
        $target.text(upperResult);
      }
    return control;
  })();
})(jQuery);
